import { FC } from 'react';
import styled from 'styled-components';

import { countryMap } from '@/shared/constants/countries-list';
import { OverflowTooltip } from '@/shared/uikitV2/OverflowTooltip';

type CountryProps = {
  code?: string;
  name?: boolean;
  icon?: boolean;
};

export const Country: FC<CountryProps> = ({ code, name, icon }) => {
  const showIcon = (!icon && !name) || icon;
  const showName = (!icon && !name) || name;
  const info = code ? countryMap.get(code) : null;

  if (!info) return '-';

  return (
    <Container>
      <OverflowTooltip tooltipValue={info.label}>
        {showIcon && info.icon}
        {showName && <span className="label">{info.label}</span>}
      </OverflowTooltip>
    </Container>
  );
};

const Container = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }

  .label {
    vertical-align: middle;
  }
`;
